function mcubeScrollTo(elem) {
	if (scrollBar) {
		scrollBar.scrollIntoView(elem);
	} else {
		elem.scrollIntoView({behavior: "smooth"});
	}
}
